<template>
    <span id="modals-endofgame">
        <b-modal id="modal-leg-end" title="Leg beendet" @hidden="nextLeg" v-if="endOfLeg">
            <template #default>
                <div class="results">
                    <template v-if="players">
                        <template v-if="players.length <= 2">
                            <game-asset-v-2-score-player
                                v-for="player, idx in players"
                                :playerIndex="idx"
                                :playerId="player.player_id"
                                :key="idx">
                            </game-asset-v-2-score-player>
                        </template>
                    </template>
                </div>
                <game-asset-game-history-v-2 v-if="useHistory == 'default'"></game-asset-game-history-v-2>
                <game-asset-v-3-history-flowliga v-if="useHistory == 'flowliga'"></game-asset-v-3-history-flowliga>
            </template>
            <template #modal-footer>
                <game-asset-next-leg @nextleg="$bvModal.hide('modal-leg-end')"></game-asset-next-leg>
            </template>
        </b-modal>

        <b-modal id="modal-game-results" :title="__('results.game_results')" @hidden="backToMatchmaking" size="xl" v-if="endOfGame">
            <template>
                <div class="results">
                    <template v-if="players">
                        <template v-if="players.length <= 2">
                            <game-asset-v-2-score-player
                                v-for="player, idx in players"
                                :playerIndex="idx"
                                :playerId="player.player_id"
                                :key="idx">
                            </game-asset-v-2-score-player>
                        </template>
                    </template>
                </div>
                <game-asset-game-history-v-2 v-if="useHistory == 'default'"></game-asset-game-history-v-2>
                <game-asset-v-3-history-flowliga v-if="useHistory == 'flowliga'"></game-asset-v-3-history-flowliga>
            </template>
            <template #modal-footer>
                <div class="statsbuttoncontainer">
                    <button type="button" class="btn btn-info btn-lg" @click.prevent="loadStatistics()">
                        <i class="fas fa-poll"></i>
                        <span>{{__('results.game_statistics')}}</span>
                    </button>
                </div>
                <game-asset-rematch :game="game"></game-asset-rematch>
            </template>
        </b-modal>
    </span>
</template>

<script>
import gameAssetV3HistoryFlowliga from '../v3/gameAssetV3HistoryFlowliga.vue';
    export default {
  components: { gameAssetV3HistoryFlowliga },
        props: ['game_prop', 'replaceHistory'],
        data() {
            return {
                game: this.game_prop,
                players: null,
                endOfLeg: false,
                endOfGame: false,
                showGameStats: false,
                useHistory: 'default',
            }
        },
        mounted() {
            window.connection.subscribe(this);
            this.update(window.connection.lastUpdate);
            if (this.replaceHistory) {
                this.useHistory = this.replaceHistory;
            }
        },
        methods: {
            update(data) {
                if (data == null) return;
                //update players from gamestate
                if (this.players == null) {
                    this.players = data.players;
                }
                if (data.action == "endOfLeg") {
                    this.endOfLeg = true;
                    setTimeout(() => {
                        this.$bvModal.show('modal-leg-end');
                    }, 250);
                }

                if (data.action == "newLegStart") {
                    this.endOfLeg = false;
                }

                if (data.action == "endOfGame") {
                    this.endOfGame = true;
                    setTimeout(() => {
                        this.$bvModal.show('modal-game-results');
                    }, 250);
                }

                if (data.action == "nextPlayer" && (this.endOfLeg || this.endOfGame)) {
                    this.endOfGame = false;
                    this.endOfLeg = false;
                    toastSuccess("Starte weiteres Leg");
                    this.$bvModal.hide('modal-leg-end');
                }
            },
            nextLeg() {
                axios.post("/api/sendReadyState", {game: this.game.id, ready: true}).then((res) => {
                    if (res.data.allready == true) {
                        toastSuccess("Starte naechstes Leg");
                        this.$bvModal.hide('modal-leg-end');
                    } else {
                        toastSuccess("Warten auf Mitspieler");
                    }
                });
            },
            backToMatchmaking() {
                axios.post("/gotourl", {url: "/dashboard/"});
            },
            loadStatistics() {
                //reloads the game, as it is over, it loads the statistics window instead of the normal window
                axios.post("/gotourl", {url: "/games/" + this.game.id});
            },
        }
    }
</script>
